import script from "./PageCardTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./PageCardTemplate.vue?vue&type=script&setup=true&lang=js"

import "./PageCardTemplate.vue?vue&type=style&index=0&id=4dd7fa68&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dd7fa68"]])

export default __exports__